/**
 * Lightweight SVG isometric parking-garage graphic. Pure illustration (no data).
 * Used as the centerpiece of the hero compass and the "why direction matters" panel.
 */
export default function IsometricGarage({
  className = '',
  upArrow = false,
  downArrow = false,
}: {
  className?: string;
  upArrow?: boolean;
  downArrow?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 200 180"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* three stacked isometric slabs */}
      {[0, 28, 56].map((dy, i) => {
        const baseY = 120 - dy;
        const top = `100,${baseY - 22} 160,${baseY + 8} 100,${baseY + 38} 40,${baseY + 8}`;
        return (
          <g key={i}>
            {/* left face */}
            <polygon
              points={`40,${baseY + 8} 100,${baseY + 38} 100,${baseY + 50} 40,${baseY + 20}`}
              fill="#cbd5e1"
            />
            {/* right face */}
            <polygon
              points={`160,${baseY + 8} 100,${baseY + 38} 100,${baseY + 50} 160,${baseY + 20}`}
              fill="#e2e8f0"
            />
            {/* top deck */}
            <polygon points={top} fill={i === 2 ? '#f1f5f9' : '#eef2f7'} stroke="#cbd5e1" strokeWidth="1" />
          </g>
        );
      })}

      {upArrow && (
        <g>
          <line x1="100" y1="44" x2="100" y2="14" stroke="#17A24A" strokeWidth="4" strokeLinecap="round" />
          <polygon points="100,6 94,18 106,18" fill="#17A24A" />
        </g>
      )}
      {downArrow && (
        <g>
          <line x1="130" y1="120" x2="130" y2="150" stroke="#F39C12" strokeWidth="4" strokeLinecap="round" />
          <polygon points="130,158 124,146 136,146" fill="#F39C12" />
        </g>
      )}
    </svg>
  );
}
